__turbopack_context__.v({
  "freeBox__jc6Y": "vvUnoG_freeBox__jc6Y",
  "freeBox__k2THm": "vvUnoG_freeBox__k2THm",
  "links": "vvUnoG_links",
  "loadingPlaceholder__bwHYf": "vvUnoG_loadingPlaceholder__bwHYf",
  "loadingPlaceholder__dIJa": "vvUnoG_loadingPlaceholder__dIJa",
  "loadingPlaceholder__hDyoY": "vvUnoG_loadingPlaceholder__hDyoY",
  "loadingPlaceholder__rvjg": "vvUnoG_loadingPlaceholder__rvjg",
  "loadingPlaceholder__up6B": "vvUnoG_loadingPlaceholder__up6B",
  "loadingPlaceholder__wlTCn": "vvUnoG_loadingPlaceholder__wlTCn",
  "newsExcerptsItem": "vvUnoG_newsExcerptsItem",
  "top": "vvUnoG_top",
});
